<template>
  <div class="home" ref="hTopome">
    <!-- 顶部固定搜索栏 -->
    <transition name="fade">
      <div class="fixed_seach">
        <div class="center">
          <div class="left">
            <div class="select" @click="toListPage(moudle.type)">应用</div>
            <div class="select" @click="toListPage(2)">动画</div>
            <div class="select" @click="toListPage(3)">视频</div>
            <div class="select" @click="toListPage(4)">字体</div>
            <div class="select" @click="toListPage(5)">音乐</div>
            <div class="select" @click="toListPage(6)">音效</div>
            <div class="select" @click="toListPage(7)">3D</div>
            <div class="select" @click="toListPage(0)">
              个人中心
            </div>
            <!--wang_start-->
            <div class="select" @click="toListPage(11)">
              激活码
            </div>
            <!--wang_end-->
          </div>
          <div class="right">
            <div class="box_seach">
              <i class="el-icon-search"></i>
              <input type="text" placeholder="搜索内容..." v-model="keyWord" @keyup.enter="resSearch" />
              <div class="button" @click="resSearch">搜索</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 登录弹窗 -->
    <el-dialog title :visible.sync="loginPopup" :before-close="handleClose" width="700px">
      <div class="login_popup">
        <div class="title">欢迎来到百视信通商城</div>
        <div class="box">
          <el-tabs v-model="activeName" stretch>
            <el-tab-pane label="账号登录" name="login">
              <div class="box-content">
                <div class="item">
                  <el-input type="text" v-model="account" placeholder="用户账号" @keyup.13.native="reslogin" />
                </div>
                <div class="item">
                  <el-input type="password" show-password @keyup.13.native="reslogin" v-model="password" placeholder="用户密码" />
                </div>
                <div class="checkbox">
                  <el-checkbox v-model="checked">自动登录</el-checkbox>
                </div>
                <el-button type="primary" @click="reslogin">登 录</el-button>
              </div>
            </el-tab-pane>
            <!-- <el-tab-pane label="注册用户" name="register">
              <div class="register">
                <div class="item">
                  <el-input type="text" v-model="phone" placeholder="手机号码" />
                </div>
                <div class="item">
                  <el-input type="password" v-model="setPassword" show-password placeholder="设置密码" />
                </div>
                <div class="item">
                  <el-input type="password" v-model="confirmPassword" show-password placeholder="确认密码" />
                </div>
                <div class="yzm">
                  <el-input v-model="sms" placeholder="验证码" />
                  <el-button type="primary" @click="resCreateSms" :disabled="smsDisabled">{{ codMsg }}</el-button>
                </div>
                <el-button type="primary" @click="resRegister">立 即 注 册</el-button>
              </div>
            </el-tab-pane> -->
          </el-tabs>
        </div>
      </div>
    </el-dialog>
    <!-- 主体 -->
    <main>
      <!-- <aside>
        <div
          v-for="(item, index) in idList"
          :key="index"
          @click="anchor(item.id)"
          :class="{ selectBgc: selectId == item.id }"
        >
          {{ item.name }}
        </div>
      </aside> -->
      <div class="main_box">
        <div id="banner"></div>
        <div class="banner">
          <div class="banner_left">
            <el-carousel :interval="3000" arrow="always" height="320px">
              <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                <img :src="item" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="banner_right">
            <div v-if="isLogin" class="logoutBox" @click="logOut">
              <img src="../../assets/logout-two.png" alt="">
              <div>退出登录</div>
            </div>

            <div class="img">
              <img :src="userImg" alt="" />
            </div>
            <div class="text">{{!isLogin?'Hi~欢迎来到百视信通商城':''}}</div>
            <div class="btns">
              <el-button v-if="!isLogin" size="small" class="login_btn" @click="loginBefore('login')">登录</el-button>
              <!-- <el-button size="small" @click="loginBefore('register')">注册</el-button> -->
              <span v-else>{{$store.state.user.user.name}}</span>
            </div>
            <div class="other">
              <div class="box">
                <img src="../../assets/收藏.png" alt="" />
                <p>我的收藏</p>
              </div>
              <div class="box">
                <img src="../../assets/购买.png" alt="" />
                <p>我的购买</p>
              </div>
              <div class="box">
                <img src="../../assets/下载.png" alt="" />
                <p>我的下载</p>
              </div>
            </div>
          </div>
          <!-- <el-carousel :interval="4000" type="card" height="300px" arrow="always">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
              <img :src="item" />
            </el-carousel-item>
          </el-carousel> -->
        </div>
        <!-- 精选推荐 -->
        <div id="recommend"></div>
        <div class="special_column">
          <div class="column_nav">
            <div class="nav_title">精选推荐</div>
          </div>
          <div class="column_content recommend">
            <img class="hover_box" :src="$img+item.image" v-for="(item, index) in recommend.dataList" :key="index" @click="toDetail(item.type,item.menus_id,item.product_id)" />
          </div>
        </div>
        <!-- 应用模板 -->
        <div id="one"></div>
        <div class="special_column">
          <div class="column_nav">
            <div class="nav_title">应用模板</div>
            <div class="type">
              <div class="item" v-for="(item, index) in moudle.typeList" :key="index" @click="moudleChangeType(moudle,index)">
                <span :class="[item.selected == true ? 'active' : 'un_active']">{{ item.name }}</span>
              </div>
            </div>
            <div class="nav_more" @click="toListPage(moudle.type)">查看更多</div>
          </div>
          <div class="column_content moudle">
            <div class="imgbox" v-for="(item, index) in moudle.dataList" :key="index">
              <div class="img">
                <img class="hover_box" @click="toDetail(moudle.type,moudle.menuId, item.product_id)" v-lazy="$img+item.image" />
              </div>
              <div class="title">{{ item.title }}</div>
            </div>
          </div>
          <!-- <div class="column_button">
            <div class="button" @click="toListPage('/images')">
              查看更多<img src="../../assets/arrow.png" />
            </div>
          </div> -->
        </div>
        <!-- 动画频道 -->
        <div id="two"></div>
        <!-- <div class="special_column">
          <div class="column_nav">
            <div class="nav_title">动画频道</div>
            <div class="nav_more" @click="toListPage(2)">查看更多</div>
          </div>
          <div class="column_content picture_library">
            <div class="imgbox" v-for="(item, index) in HotProduct[4].data" :key="index">
              <div class="img">
                <img class="hover_box" @click="toDetail(3, item.product_id)" v-lazy="$img + item.image" />
              </div>

              <div class="title">{{ item.title }}</div>
            </div>
          </div>
        </div> -->

        <!-- 视频频道 -->
        <div id="three"></div>
        <!-- <div class="special_column">
          <div class="column_nav">
            <div class="nav_title">视频频道</div>
            <div class="nav_more" @click="toListPage(3)">查看更多</div>
          </div>
          <div class="column_content video">
            <div class="imgbox" v-for="(item, index) in HotProduct[3].data" :key="index">
              <div class="img">
                <img class="hover_box" @click="toDetail(4, item.product_id)" v-lazy="$img + item.image" />
              </div>

              <div class="title">{{ item.title }}</div>
            </div>
          </div>
        </div> -->

        <!-- 热门字体 -->
        <div id="four"></div>
        <!-- <div class="special_column">
          <div class="column_nav">
            <div class="nav_title">热门字体</div>
            <div class="nav_more" @click="toListPage(4)">查看更多</div>
          </div>
          <div class="column_content hot_fonts">
            <div class="imgbox" v-for="(item, index) in HotProduct[1].data" :key="index">
              <div class="img">
                <img class="hover_box" @click="toDetail(2, item.product_id)" v-lazy="$img + item.image" />
              </div>

              <div class="title">{{ item.title }}</div>
            </div>
          </div>
        </div> -->

        <!-- 音乐库 -->
        <div id="five"></div>
        <!-- <div class="special_column">
          <div class="column_nav">
            <div class="nav_title">音乐库</div>
            <div class="nav_more" @click="toListPage(5)">查看更多</div>
          </div>
          <div class="column_content audio">
            <div class="imgbox" v-for="(item, index) in HotProduct[4].data" :key="index">
              <div class="img">
                <img class="hover_box" @click="toDetail(5, item.product_id)" src="../../assets/dish.png" />
              </div>
              <div class="title">{{ item.title }}</div>
            </div>
          </div>
        </div> -->

        <!-- 音效库 -->
        <div id="six"></div>
        <!-- <div class="special_column">
          <div class="column_nav">
            <div class="nav_title">音效库</div>
            <div class="nav_more" @click="toListPage(6)">查看更多</div>
          </div>
          <div class="column_content audio">
            <div class="imgbox" v-for="(item, index) in HotProduct[7].data" :key="index">
              <div class="img">
                <img class="hover_box" @click="toDetail(7, item.product_id)" src="../../assets/dish.png" />
              </div>
              <div class="title">{{ item.title }}</div>
            </div>
          </div>
        </div> -->
        <!-- 3d模型 -->
        <div id="seven"></div>
        <!-- <div class="special_column">
          <div class="column_nav">
            <div class="nav_title">3D模型</div>
            <div class="nav_more" @click="toListPage(7)">
              查看更多
            </div>
          </div>
          <div class="column_content Model">
            <div class="imgbox" v-for="(item, index) in HotProduct[5].data" :key="index">
              <div class="img">
                <img class="hover_box" @click="toDetail(6, item.product_id)" v-lazy="$img + item.image" />
              </div>
              <div class="title">{{ item.title }}</div>
            </div>
          </div>
        </div> -->
      </div>
      <!-- 下载 -->
      <downloadProduct ref="myDown" :dialogStatus="down.dialog" @close="close"></downloadProduct>
    </main>
    <div class="backTop" @click="anchor('banner')" v-show="selectId != 'one'">
      <i class="el-icon-caret-top"></i>
      <br />TOP
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import {
  getList, getCategoryByType,
  login,
  register,
  createSms,
  getBanner,
  buyResource
} from '../../api/index'
import downloadProduct from '../../components/downloadProduct/downloadProduct'
import imageDialog from '../../components/imageDialog/imageDialog'
import specialDialog from '../../components/specialDialog/specialDialog'
import videoDialog from '../../components/videoDialog/videoDialog'
import fontsDialog from '../../components/fontsDialog/fontsDialog'
import audioDialog from '../../components/audioDialog/audioDialog'

export default {
  data () {
    return {
      idList: [
        {
          id: 'one',
          name: '应用模板'
        },
        {
          id: 'two',
          name: '动画频道'
        },
        {
          id: 'three',
          name: '视频频道'
        },
        {
          id: 'four',
          name: '热门字体'
        },
        {
          id: 'five',
          name: '音乐库'
        },
        {
          id: 'six',
          name: '音效库'
        },
        {
          id: 'seven',
          name: '3D模型'
        }
      ],
      selectId: 'one',
      // recommend: [ // 精选推荐
      //   {
      //     type: 1,
      //     menus_id: 1,
      //     product_id: 2,
      //     image: require('../../assets/start1.jpg'),
      //     keyword: '热门'
      //   },
      //   {
      //     type: 1,
      //     menus_id: 2,
      //     product_id: 1292,
      //     image: require('../../assets/start2.jpg'),
      //     keyword: '直播'
      //   },
      //   {
      //     type: 1,
      //     menus_id: 3,
      //     product_id: 1299,
      //     image: require('../../assets/start3.jpg'),
      //     keyword: 'vlog'
      //   },
      //   {
      //     type: 1,
      //     menus_id: 4,
      //     product_id: 1334,
      //     image: require('../../assets/start4.jpg'),
      //     keyword: 'vlog'
      //   },
      //   {
      //     type: 1,
      //     menus_id: 5,
      //     product_id: 1353,
      //     image: require('../../assets/start5.jpg'),
      //     keyword: 'vlog'
      //   }
      // ],
      recommend: {
        type: 0,
        dataList: []
      },
      moudle: {
        type: 1,
        menuId: 0,
        typeList: [],
        dataList: []
      }, // 应用模板数据
      animation: {
        type: 2,
        menuId: 0,
        typeList: [],
        dataList: []
      },
      video: {
        type: 3,
        menuId: 0,
        typeList: [],
        dataList: []
      },
      loginPopup: false, // 登录弹窗
      activeName: 'login',
      account: '', // 账号
      password: '', // 密码
      phone: '',
      setPassword: '',
      confirmPassword: '',
      sms: '',
      codMsg: '获取短信验证码',
      smsTime: '', // 定时器
      smsDisabled: false,
      checked: true, // 自动登录
      isFixedTop: false, // 顶部搜索栏是否显示
      isFixedRight: false, // 右侧信息栏是否显示
      categoryList: [], // 资源分类数据
      bannerList: [
        'http://docer.op.wpscdn.cn/odimg/web/2021-01-21-14-10/xinguofengppt668_312.jpg',
        'http://docer.op.wpscdn.cn/odimg/web/2021-02-02-09-36/fuguhuacefeng668_312.png',
        'http://docer.op.wpscdn.cn/odimg/web/2021-03-01-11-55/jiandang100zhounian668_312.jpg',
        'http://docer.op.wpscdn.cn/odimg/web/2021-01-15-17-21/21shiji668312.jpg'

      ], // 轮播图数据
      hotSeach: [
        {
          name: '热门'
        },
        {
          name: '办公'
        },
        {
          name: '自然'
        },
        {
          name: '娱乐'
        }
      ], // 热门搜索
      // HotProduct: [
      //   { data: [] },
      //   { data: [] },
      //   { data: [] },
      //   { data: [] },
      //   { data: [] },
      //   { data: [] },
      //   { data: [] }
      // ], // 顶部热门数据
      keyWord: '', // 搜索关键字
      product_id: 0, // 商品id
      down: { dialog: false }, // 下载参数
      imageDialog: { dialog: false }, // 图片弹窗
      specialDialog: { dialog: false },
      videoDialog: { dialog: false },
      fontsDialog: { dialog: false },
      audioDialog: { dialog: false }
    }
  },
  components: {
    downloadProduct,
    imageDialog,
    specialDialog,
    videoDialog,
    fontsDialog,
    audioDialog
  },
  created () {
    this.getHotRecommend(this.recommend, 0, 5)
    this.getAllData()
  },
  mounted () {
    // window.onscroll = this.watchTop
  },
  methods: {
    ...mapMutations([

    ]),
    ...mapActions('data', [
      'getHotData',
      'getCategory',
      'getCategoryData'
    ]),
    // 精选推荐跳转
    recommendJump (index) {
      this.$router.push({ path: '/search?keyword=' + this.recommend[index].keyword })
    },
    // -------------------- 页面
    // 监听滚动距离
    // watchTop () {
    //   var scrollTop =
    //     document.documentElement.scrollTop || document.body.scrollTop
    //   this.idList.forEach(item => {
    //     if (scrollTop > (document.getElementById(item.id).offsetTop - 200)) {
    //       this.selectId = item.id
    //     }
    //   })
    // },
    In () {
      this.isFixedRight = true
    },
    Out () {
      this.isFixedRight = false
    },
    stop () { },
    // 退出登录
    logOut () {
      this.$store.commit('user/logOut')
    },
    jump (type, menu_id, category_id) {
      if (type === 1) {
        this.$router.push({
          path: '/images',
          query: { menu_id: menu_id, category_id: category_id }
        })
      } else if (type === 3) {
        this.$router.push({
          path: '/modules',
          query: { menu_id: menu_id, category_id: category_id }
        })
      } else if (type === 4) {
        this.$router.push({
          path: '/videos',
          query: { menu_id: menu_id, category_id: category_id }
        })
      } else if (type === 2) {
        this.$router.push({
          path: '/fonts',
          query: { menu_id: menu_id, category_id: category_id }
        })
      } else if (type === 5) {
        this.$router.push({
          path: '/audios',
          query: { menu_id: menu_id, category_id: category_id }
        })
      } else if (type === 6) {
        this.$router.push({
          path: '/dimension',
          query: { menu_id: menu_id, category_id: category_id }
        })
      }
    },
    // 模块跳转
    toListPage (type) {
      if (type === 0) {
        // 个人中心
        this.$router.push({ path: '/personal_center' })
      } else if (type === 11) {
        // 激活码
        this.$router.push({ path: '/code' })
      } else {
        this.$router.push({ path: '/product_list', query: { type: type } })
      }
      // wang_start
      // if (type === 11) {
      //   // 激活码
      //   this.$router.push({ path: '/code' })
      // } else {
      //   this.$router.push({ path: '/product_list', query: { type: type } })
      // }
      // wang_end
    },
    // 去个人中心
    toPersonal () {
      if (this.$store.state.user.token) {
        this.$router.push({ path: '/personal_center' })
      } else {
        this.loginBefore()
      }
    },
    // 唤起登录窗口
    loginBefore (type) {
      this.activeName = type
      this.loginPopup = true
    },
    // 关闭登录窗口
    handleClose (done) {
      this.account = this.password = ''
      this.phone = this.setPassword = this.confirmPassword = this.sms = ''
      clearInterval(this.smsTime)
      this.smsDisabled = false
      this.codMsg = '获取短信验证码'
      done()
    },
    // 轮播图跳转
    bannerUrl (url) {
      this.$router.push({ path: url })
    },
    // 窗口
    clickPopup (dialog, id) {
      dialog.dialog = true
      this.product_id = id
    },
    // 下载
    download (details) {
      buyResource({ product_id: details.product_id }, (res) => {
        if (res.status === 'success') {
          this.down = details
          this.down.dialog = true
          // console.log(this.down)
          this.$refs.myDown.download(details)
        }
      })
    },
    // 关闭下载
    close () {
      this.down.dialog = false
    },
    // 跳转详情页
    toDetail (type, menuId, id) {
      this.$router.push({
        path: '/product_detail',
        query: {
          type: type,
          menus_id: menuId,
          product_id: id
        }
      })
    },
    // 锚链接跳转
    anchor (id) {
      this.selectId = id
      window.scrollTo(0, document.getElementById(id).offsetTop - 80) // 垂直滚动到1000的位置
      // console.log(window.scroll)
      // document.getElementById(id).scrollIntoView(true);
    },

    // -------------------- 接口
    // 登录
    reslogin () {
      login(
        {
          phone: this.account,
          password: this.password
        },
        (res) => {
          if (res.status === 'success') {
            const user = res.result.data
            const loginType = this.checked ? 'user/login' : 'user/loginTemp'
            this.$store.commit(loginType, {
              user: user,
              token: res.result.token
            })
            this.loginPopup = false
            this.$message.success('登录成功')
          } else {
            this.password = ''
            this.$message.error(res.result)
          }
        }
      )
    },
    // 注册
    resRegister () {
      if (!this.phone) this.$message.warning('请填写手机号')
      else if (!this.setPassword) this.$message.warning('请设置密码')
      else if (!this.confirmPassword) this.$message.warning('请再次确认密码')
      else if (this.setPassword !== this.confirmPassword) { this.$message.error('两次密码不一致') } else if (!this.sms) this.$message.warning('请输入验证码')
      else {
        register(
          {
            phone: this.phone,
            code: this.sms,
            password: this.setPassword
          },
          (res) => {
            if (res.status === 'success') {
              this.$message.success('注册成功')
              this.phone = this.setPassword = this.confirmPassword = this.sms =
                ''
              clearInterval(this.smsTime)
              this.smsDisabled = false
              this.codMsg = '获取短信验证码'
              this.activeName = 'login'
            } else {
              this.$message.error(res.result)
            }
          }
        )
      }
    },
    // 获取验证码
    resCreateSms () {
      if (this.phone) {
        const reg = /^1[3-9]\d{9}$/
        if (!reg.test(this.phone)) {
          this.$message.error('请填写正确的手机号码格式')
          return
        }
        let S = 60
        this.smsDisabled = true
        this.smsTime = setInterval(() => {
          S--
          if (S === 0) {
            clearInterval(this.smsTime)
            this.smsDisabled = false
            this.codMsg = '获取短信验证码'
            return
          }
          this.codMsg = S + 'S 后重新获取'
        }, 1000)
        createSms(
          {
            phone: this.phone
          },
          (res) => {
            if (res.status === true) {
              this.$message.success('验证码已发送，请注意查收')
            } else {
              this.$message.success('发送失败')
            }
          }
        )
      } else {
        this.$message.warning('请填写手机号')
      }
    },

    // ======================获取首页所有数据===============================

    // 获取推荐数据
    getHotRecommend (payload, offset, length) {
      return new Promise((resolve, reject) => {
        this.getHotData({
          type: payload.type,
          offset: offset,
          length: length
        }).then(res => {
          payload.dataList = res
          resolve()
        })
      })
    },
    // 获取模板分类
    getMoudleCategory (payload) {
      return new Promise((resolve, reject) => {
        this.getCategory({
          type: payload.type
        }).then(res => {
          const ress = JSON.parse(JSON.stringify(res))
          // 添加选择状态 'selected'
          ress.forEach((item, index) => {
            ress[index].selected = false
          })
          payload.typeList = ress
          this.getHotRecommend(payload, 0, 20).then(() => {
            resolve(payload.type)
          })
        })
      })
    },
    // 获取模板数据
    getMoudleLists (payload) {
      this.getCategoryData({
        type: payload.type,
        menuId: payload.menuId
      }).then(res => {
        this.moudle.dataList = res
      })
    },
    // 点击选择类型
    moudleChangeType (payload, index) {
      payload.typeList.forEach((item, index) => {
        payload.typeList[index].selected = false
      })
      payload.typeList[index].selected = true
      payload.menuId = payload.typeList[index].id
      this.getMoudleLists(payload)
    },
    // 链式调用获取首页所有数据
    getAllData () {
      this.getMoudleCategory(this.moudle).then((data) => {
        console.log('type' + data + '请求完成')
        return this.getMoudleCategory(this.animation)
      }).then((data) => {
        console.log('type' + data + '请求完成')
        return this.getMoudleCategory(this.video)
      }).then((data) => {
        console.log('type' + data + '请求完成')
      })
    },
    //= =============================================================

    // 获取轮播图
    resBanner (res) {
      if (res.status === 'success') {
        this.bannerList = res.result.data
      }
    },
    // 搜索
    resSearch () {
      if (this.keyWord) {
        this.$router.push({ path: '/search?keyword=' + this.keyWord })
      }
    },
    // 点击热门搜索
    hotClick (val) {
      this.keyWord = val
      setTimeout(() => {
        this.$router.push({ path: '/search?keyword=' + val })
      })
    },
    // 获取热门搜索
    resHotProduct (res) {
      if (res.status === 'success') {
        // res.result.forEach((item, index) => {
        //   // if (item.length < 6)
        //   item.data = item.data.concat(item.data)
        // })
        res.result.sort((a, b) => {
          var value1 = a.type
          var value2 = b.type
          return value1 - value2
        })
        // this.HotProduct = res.result
        this.$store.commit('storageHome', res.result)
      }
    },
    loadImage (obj, url, callback) {
      var img = new Image()
      img.src = url

      // 判断图片是否在缓存中
      if (img.complete) {
        callback.call(img, obj)
        return
      }

      // 图片加载到浏览器的缓存中回调函数
      img.onload = function () {
        callback.call(img, obj)
      }
    },

    showImage (obj) {
      obj.src = this.src
    }
  },
  computed: {
    userImg () {
      if (this.$store.state.user.token) {
        return this.$img + this.$store.state.user.user.image
        // return ''
      } else {
        return require('../../assets/head.png')
      }
    },
    isLogin () {
      return !!this.$store.state.user.token
    },
    HotProduct () {
      if (this.$store.state.homeMsg) { return this.$store.state.homeMsg } else {
        return [
          { data: [] },
          { data: [] },
          { data: [] },
          { data: [] },
          { data: [] },
          { data: [] },
          { data: [] },
          { data: [] }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
.home {
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  min-width: 864px;
  height: 100vh;
  // 顶部导航栏
  .fixed_seach {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    max-width: 1080px;
    box-sizing: border-box;
    margin: 0 auto;
    height: 80px;
    background-color: #ffffff;
    box-shadow: 0 1px 1px #e0e0e0;
    z-index: 98;
    padding: 0 20px;
    .center {
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
        height: 80px;
        .select {
          width: 80px;
          height: 80px;
          line-height: 80px;
          text-align: center;
          font-size: 16px;
          // font-family: "朦胧黑体";
          // font-weight: 600;
          color: #222222;
          cursor: pointer;
        }
        .select:hover {
          background: rgba(120, 120, 120, 0.6);
        }
      }
      .right {
        display: flex;
        align-items: center;
        height: 80px;
        .box_seach {
          width: 280px;
          height: 36px;
          background-color: #fff;
          border-radius: 4px;
          display: flex;
          align-items: center;
          overflow: hidden;
          pointer-events: auto;
          border: 1px solid #50708c;
          i {
            width: 20px;
            padding: 0 10px;
            font-size: 20px;
            color: #aaaaaa;
          }
          input {
            flex: 1;
            height: 30px;
            font-size: 14px;
            border: none;
            outline: none;
            color: #666;
          }
          .button {
            width: 60px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            background-color: #ffffff;
            font-size: 13px;
            color: #50708c;
            cursor: pointer;
            user-select: none;
          }
        }
      }
    }
  }
  .login_popup {
    min-height: 500px;
    .title {
      width: 100%;
      text-align: center;
      font-size: 30px;
    }
    .box {
      width: 500px;
      height: 360px;
      margin: 30px auto;
      border: 1px solid #eeeeee;
      border-radius: 4px;
      .box-content {
        height: 280px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .item {
          width: 60%;
          height: 40px;
          margin-bottom: 20px;
        }
        .item:first-child {
          margin-bottom: 30px;
        }
        .checkbox {
          width: 60%;
          padding-bottom: 10px;
          .el-checkbox {
            color: #999999;
          }
        }
        .el-button {
          width: 60%;
        }
      }
      .register {
        height: 280px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .item {
          margin-bottom: 15px;
          width: 60%;
          height: 40px;
        }

        .yzm {
          width: 60%;
          height: 40px;
          display: flex;
          margin-bottom: 20px;
          .el-input {
            width: 100px;
          }
          .el-button {
            flex: 1;
            margin-left: 10px;
          }
        }
        .el-button {
          width: 60%;
        }
      }
    }
  }
  main {
    width: 100%;
    min-height: calc(100vh - 400px);
    background-color: #f4f4f4;
    aside {
      position: fixed;
      top: 40%;
      left: 2%;
      transform: translateY(-50%);
      width: 13%;
      // height: 400px;
      border-radius: 10px;
      background-color: #ffffff;
      padding: 20px;
      box-sizing: border-box;
      box-shadow: 0 0 4px #e0e0e0;
      div {
        height: 40px;
        line-height: 40px;
        margin-bottom: 10px;
        text-align: center;
        border-radius: 20px;
        cursor: pointer;
        font-size: 14px;
      }
      div:last-child {
        margin-bottom: 0;
      }
      .selectBgc {
        background: #018bfd;
        color: #fff;
      }
    }
    .main_box {
      width: 100%;
      margin: 0 auto;
      // transform: translateX(30px);
      padding-top: 80px;
      padding-bottom: 100px;

      .banner {
        height: 320px;
        padding: 15px 10px;
        display: flex;
        .banner_left {
          width: 780px;
          height: 320px;
          .el-carousel {
            border-radius: 6px;
          }
          .el-carousel__item {
            display: flex;
            justify-content: center;
            img {
              display: block;
              width: 100%;
              margin: 0 auto;
            }
          }
        }
        .banner_right {
          margin-left: 20px;
          flex: 1;
          min-width: 300px;
          height: 320px;
          background-color: #ffffff;
          border-radius: 6px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          position: relative;
          .logoutBox {
            cursor: pointer;
            text-align: center;
            color: #a7a7a7;
            font-size: 12px;
            top: 10px;
            right: 10px;
            position: absolute;
            img {
              width: 30px;
              height: 30px;
            }
          }
          .img {
            width: 280px;
            height: 70px;
            display: flex;
            justify-content: center;
            img {
              border-radius: 8px;
              width: 60px;
              height: 60px;
            }
          }
          .text {
            width: 280px;
            text-align: center;
            color: #a7a7a7;
            font-size: 12px;
          }
          .btns {
            width: 240px;
            height: 60px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            .el-button {
              width: 100px;
            }
            .login_btn {
              background-color: #475669;
              color: #ffffff;
            }
          }
          .other {
            width: 240px;
            height: 80px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            .box {
              cursor: pointer;
              height: 80px;
              width: 60px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              img {
                width: 26px;
                height: 26px;
                display: block;
                margin-bottom: 10px;
              }
              p {
                color: #a7a7a7;
                font-size: 12px;
              }
            }
          }
        }

        .el-carousel__item {
          border-radius: 6px;
          display: flex;
          justify-content: center;
          img {
            display: block;
            height: 100%;
            margin: 0 auto;
          }
        }
        .el-carousel__item h3 {
          color: #475669;
          font-size: 14px;
          opacity: 0.75;
          line-height: 200px;
          margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
          background-color: #99a9bf;
        }

        .el-carousel__item:nth-child(2n + 1) {
          background-color: #d3dce6;
        }
      }
      .special_column {
        background-color: #fff;
        margin-bottom: 20px;
        box-shadow: 0 0 6px #e0e0e0;
        // border-radius: 10px;
        padding: 0 20px;
        padding-bottom: 20px;
        box-sizing: border-box;
        .column_nav {
          padding: 20px 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .nav_title {
            font-size: 19px;
            font-weight: 700;
            color: #222222;
            margin-right: 30px;
          }
          .type {
            flex: 1;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            height: 25px;
            background-color: #fff;
            .item {
              margin-right: 40px;
            }
            .item:hover span {
              color: #ea7d4b;
              cursor: pointer;
            }
            .active {
              color: #ea7d4b;
            }
            .un_active {
              color: #666;
            }
          }
          .nav_more {
            font-size: 16px;
            color: #666666;
            cursor: pointer;
          }
          .nav_list {
            display: flex;
            .nav_item {
              margin-right: 20px;
              font-size: 14px;
              color: #999999;
              cursor: pointer;
            }
            .nav_item:first-child {
              color: #e55d3f;
            }
            .nav_item:hover {
              color: #e55d3f;
            }
          }
        }
        .column_content {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          img {
            width: 19%;
            background-color: #ffffff;
          }
          .imgbox {
            width: 19%;
            padding: 10px;
            margin-bottom: 15px;
            box-sizing: border-box;
            background-color: #ffffff;
            cursor: pointer;
            box-shadow: 0 0 4px #dddddd;
            border-radius: 6px;
            transition: all 0.3s;
            display: flex;
            flex-direction: column;
            .img {
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
              // max-height: 250px;
              overflow: hidden;
            }
            img {
              width: 100%;
              background-color: #ffffff;
            }
          }
          .imgbox:hover {
            box-shadow: 0 0 8px #cccccc;
            margin-top: -5px;
            margin-bottom: 5px;
          }
          .title {
            height: 30px;
            line-height: 30px;
            font-size: 13px;
            color: #666666;
            background-color: #ffffff;
          }
        }
        .column_button {
          width: 100%;
          height: 60px;
          .button {
            margin: 10px auto;
            margin-top: 20px;
            width: 200px;
            height: 40px;
            text-align: center;
            background-color: #f60;
            color: #ffdec8;
            border-radius: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            user-select: none;
            cursor: pointer;
            img {
              width: 18px;
              height: 18px;
              margin-left: 5px;
            }
          }
        }
        // 精选推荐
        .recommend img {
          height: auto;
          border-radius: 6px;
        }
        // 应用模板
        .moudle {
          flex: none;
          min-height: 330px;
          .img {
            flex: 1 !important;
            overflow: hidden;
            // display: flex;
            // justify-content: center;
            // align-items: center;
            // img {
            //   height: 100%;
            // }
          }
        }

        // 动画频道
        .picture_library {
          // min-height: 310px;
          img {
            height: auto;
          }
        }

        .video {
          // min-height: 440px;
          img {
            height: auto;
          }
        }
        // 热门字体
        .hot_fonts {
          // min-height: 175px;
          img {
            height: auto;
          }
        }

        // 音频库
        .audio {
          // min-height: 240px;
          img {
            height: auto;
          }
        }
        // 3D模型
        .Model {
          // min-height: 170px;
          img {
            height: auto;
          }
        }
      }
    }
  }
  .backTop {
    position: fixed;
    bottom: 40px;
    right: 20px;
    width: 80px;
    height: 80px;
    background-color: #ffffff;
    border-radius: 10px;
    color: #018bfd;
    text-align: center;
    font-size: 20px;
    i {
      font-size: 28px;
      margin-top: 10px;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
  opacity: 0;
}
</style>
